import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

export type PublicRouteProps = RouteProps & {
  restricted?: boolean;
  fallback?: string;
};

/**
 * The user can access a public route except when this access is restricted.
 */
function PublicRoute(props: PublicRouteProps) {
  const { restricted = false, fallback = "/", ...routeProps } = props;
  const { loggedIn } = useAuth();

  return (
    <>
      {loggedIn && restricted ? (
        <Redirect to={fallback} />
      ) : (
        <Route {...routeProps} />
      )}
    </>
  );
}

export default PublicRoute;
